import gemImg from '~/assets/gem.svg'

import isNetworkError from 'is-network-error'
import { isHTTPError, isTimeoutError } from 'ky'
import { createEffect, Show, Suspense } from 'solid-js'
import { native } from '@forest/native-services'
import { m } from '~/paraglide/messages'
import { useBalanceQuery } from '~/resources/currency'
import { showDialog } from '~/store/dialog'
import { Spinner } from './spinner'

export function CurrencyBar() {
  const query = useBalanceQuery()

  createEffect(() => {
    if (!query.error) return
    if (
      isTimeoutError(query.error) ||
      (isNetworkError as (error: unknown) => boolean)(query.error)
    ) {
      showDialog({
        title: m.dialog_data_load_fail_title(),
        description: m.dialog_data_load_fail_description(),
        primaryButtonText: m.ok(),
        primaryAction: () => {
          native.general.close()
        },
      })
      return
    }
    showDialog({
      title: m.dialog_data_load_fail_title(),
      description: m.error_code_general({
        status: isHTTPError(query.error)
          ? query.error.response.status
          : query.error.message,
      }),
      primaryButtonText: m.ok(),
      primaryAction: () => {
        native.general.close()
      },
    })
  })

  return (
    <div class="flex p-[5px]">
      <div class="flex h-[26px] items-center space-x-1 rounded-full bg-black/20 px-[5px] font-rubik text-white">
        <img class="size-5" src={gemImg} alt="gem" />
        <Suspense fallback={<Spinner class="size-4" />}>
          <Show when={query.data} fallback={<Spinner />}>
            <span>{query.data?.gem}</span>
          </Show>
        </Suspense>
      </div>
    </div>
  )
}
